import './TagRow.scss';
import { capitalize } from 'inflected';
import { ListGroup } from 'react-bootstrap';
import { Button } from '@Components/Button';
import { AD_SERVER_MAP } from '@Components/CreativeAllocation';
import { Checkbox } from '@Components/FormCheck';
import { Appearance, Size } from '@Components/designConstants';
import { TagData } from './utils';

interface TagRowProps {
  tags: TagData[];
  onAdd: (tag: TagData, isEditMode: boolean) => void;
  suppressTag: (derivedID: string) => void;
  isSelected: boolean;
  onToggleSelect: (derivedID: string) => void;
}

export const TagRow = ({ tags, onAdd, suppressTag, isSelected, onToggleSelect }: TagRowProps) => {
  const firstTag = tags[0];
  const { derivedID, network, description, platform, dsp, hasOverride, hasPlacement } = firstTag;

  const tagMap: Record<string, TagData> = {};
  for (const tag of tags) {
    tagMap[(tag as any).placementName] = tag;
  }

  return (
    <ListGroup.Item
      className='placement-row'
      variant={isSelected ? 'info' : undefined}
      data-testid={`tag-row-${derivedID}`}
    >
      <div>
        <Checkbox
          checked={Boolean(isSelected)}
          onChange={() => onToggleSelect(derivedID)}
          onClick={e => e.stopPropagation()}
        />
        <div className='metadata'>
          {`${derivedID} | ${network} |${description ? ` ${description} |` : ''} ${platform}${dsp ? ` | DSP: ${dsp}` : ''}`}
          {hasOverride ? (
            <span className='suppressed'>Suppressed</span>
          ) : (
            <Button
              appearance={Appearance.EMPTY}
              size={Size.SM}
              onClick={() => suppressTag(derivedID)}
            >
              Suppress
            </Button>
          )}
        </div>
        <Button size={Size.SM} onClick={() => onAdd(firstTag, false)}>
          Create Tag
        </Button>
      </div>
      {hasPlacement &&
        Object.values(tagMap).map(tag => {
          const anyTag = tag as any;
          let adServerLabel = anyTag.adServer as string;
          if (AD_SERVER_MAP[anyTag.adServer]) {
            adServerLabel = AD_SERVER_MAP[anyTag.adServer];
          } else if (anyTag.adServer) {
            adServerLabel = capitalize(anyTag.adServer);
          }
          return (
            <div key={anyTag.placementName} className='existing-tag'>
              Ad Server: {adServerLabel}, Placement Name: {anyTag.placementName}, Campaign:{' '}
              {anyTag.campaignName}
            </div>
          );
        })}
    </ListGroup.Item>
  );
};
